/* global axios */
import ApiClient from '../ApiClient';

class CaptainActionLogs extends ApiClient {
  constructor() {
    super('captain_action_logs', { accountScoped: true });
  }

  get({ assistantId, page = 1, status, toolName, fromDate, toDate } = {}) {
    return axios.get(this.url, {
      params: {
        assistant_id: assistantId,
        page,
        status,
        tool_name: toolName,
        from_date: fromDate,
        to_date: toDate,
      },
    });
  }

  approve(id, { notes } = {}) {
    return axios.post(`${this.url}/${id}/approve`, { notes });
  }

  block(id, { notes } = {}) {
    return axios.post(`${this.url}/${id}/block`, { notes });
  }
}

export default new CaptainActionLogs();
